export default function Hero() {
  return (
    <section className="hero">
      <img
        className="hero-bg"
        src={`${process.env.PUBLIC_URL}/assets/hero.jpeg`}
        alt=""
        aria-hidden="true"
      />
      <div className="scrim" aria-hidden="true"></div>
      <div className="hero-inner">
        <div className="wrap">
          <p className="eyebrow paper">Φροντιστήριο Μ.Ε. · Μυτιλήνη</p>
          <h1>Η γνώση γίνεται <span className="dot">πράξη<span style={{ color: 'var(--red)' }}>.</span></span></h1>
          <p className="sub">Από το 2010, προετοιμάζουμε τους μαθητές της Λέσβου για τις Πανελλαδικές με μέθοδο, συνέπεια και αποτελέσματα που μιλούν από μόνα τους.</p>
          <p className="directors">Υπεύθυνοι σπουδών: <strong>Ιωάννης Τσουκαλοχωρίτης</strong> & <strong>Κωνσταντίνος Ράπτης</strong></p>
          <div className="cta-row">
            <a className="btn btn-red" href="#contact">Κλείστε ραντεβού</a>
            <a className="btn btn-ghost" href="#why">Δείτε τις παροχές</a>
          </div>
          <div className="meta">
            <span><span className="pip"></span> Πρωτιές στο νομό Λέσβου</span>
            <span><span className="pip b"></span> Ολιγομελή τμήματα</span>
            <span><span className="pip"></span> Δωρεάν αναγνωστήριο</span>
          </div>
        </div>
      </div>
    </section>
  );
}
